@if (queryProperty && queryProperties && queryProperties.length > 0) {
  <div style="width: 200px;">
    @if (queryProperty.type == queryPropertyType.Select) {
      <custom-select
        [placeholder]="'query.select-placeholder' | translate"
        [selectList]="selectList"
        [value]="value"
        (valueChange)="updateValue($event)">
      </custom-select>
    }
    @else if (queryProperty.customProperty == queryCustomType.TaskTemplateTag) {
      <custom-select
        [placeholder]="'query.task-template-tag-placeholder' | translate"
        [selectList]="taskTemplateTagList"
        [value]="value"
        (valueChange)="updateValue($event)">
      </custom-select>
    }
    @else if (queryProperty.customProperty == queryCustomType.TaskflowTemplateTag) {
      <custom-select
        [placeholder]="'query.taskflow-template-tag-placeholder' | translate"
        [selectList]="taskflowTemplateTagList"
        [value]="value"
        (valueChange)="updateValue($event)">
      </custom-select>
    }
    @else if (queryProperty.type == queryPropertyType.InputTeamId) {
      <custom-select
        [placeholder]="'query.assigned-user-placeholder' | translate"
        [selectList]="userTeamList"
        [value]="value"
        (valueChange)="updateValue($event)">
      </custom-select>
    }
    @else if (queryProperty.type == queryPropertyType.InputUserId) {
      <custom-select
        [placeholder]="'query.reference-users-placeholder' | translate"
        [selectList]="usersList"
        [value]="value"
        (valueChange)="updateValue($event)">
      </custom-select>
    }
    @else if (queryProperty.customProperty == queryCustomType.TaskActionOnActiveStep) {
      <custom-select
        [placeholder]="'query.task-action-on-active-step-placeholder' | translate"
        [selectList]="selectList"
        [value]="value"
        [required]="true"
        (valueChange)="updateValue($event)">
      </custom-select>
    }
    @else if (queryProperty.valueType == queryPropertyValueType.Text) {
      <custom-input [inputType]="inputTypeEnum.Text" [value]="value" (valueChange)="updateValue($event)" />
    }
    @else if (queryProperty.valueType == queryPropertyValueType.Numeric) {
      <custom-input [inputType]="inputTypeEnum.Number" [value]="value" (valueChange)="updateValue($event)" />
    }
    @else if (queryProperty.valueType == queryPropertyValueType.Date) {
      <date-input (valueChange)="updateValue($event)" />
    }
  </div>
}
